import { Component } from '@angular/core'

@Component({
  selector: 'cover-new-credit-card',
  templateUrl: './new-credit-card.component.html',
  styleUrls: ['./new-credit-card.component.scss'],
})
export class NewCreditCardComponent {}
